// src/features/ACS-Dashboard-Modules/Appointments/TabContent/Calendar-Main/DayOfWeekMultiSelect.js
import React from "react";

const DAYS = [
  { value: "MONDAY", label: "M" },
  { value: "TUESDAY", label: "T" },
  { value: "WEDNESDAY", label: "W" },
  { value: "THURSDAY", label: "T" },
  { value: "FRIDAY", label: "F" },
  { value: "SATURDAY", label: "S" },
  { value: "SUNDAY", label: "S" },
];

const DayOfWeekMultiSelect = ({ value = [], onChange, disabled = false }) => {
  const toggleDay = (day) => {
    if (disabled) return;
    const next = value.includes(day)
      ? value.filter((d) => d !== day)
      : [...value, day];
    onChange(next);
  };

  return (
    <div className="flex items-center gap-1" role="group" aria-label="Days of week">
      {DAYS.map(({ value: day, label }) => {
        const isSelected = value.includes(day);
        return (
          <button
            key={day}
            type="button"
            onClick={() => toggleDay(day)}
            disabled={disabled}
            aria-pressed={isSelected}
            aria-label={day}
            title={day}
            className={`
              w-7 h-7 rounded-full text-fluid-xs font-semibold
              flex items-center justify-center
              border transition
              ${isSelected
                ? "bg-[#1e2a74] border-[#1e2a74] text-white"
                : "bg-white border-gray-300 text-gray-600 hover:border-acs-primary-blue/50"
              }
              ${disabled ? "opacity-60 cursor-not-allowed" : ""}
            `}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
};

export default DayOfWeekMultiSelect;
